import React, { Fragment } from "react";
import RedLogo from "../Mentors/RedLogo";

const ReportUserConfirm = ({
  user,
  reportedUser: {
    role,
    avatar,
    firstname,
    lastname,
    jobtitle,
    location,
    racism,
    inappropriate,
    spam,
    impersonation,
    threat,
    other,
    text,
  },
  setReportUserOpen,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="subscription-box-confirmation">
          <i
            className="far fa-times-circle red fa-3x subscription-x"
            onClick={() => setReportUserOpen({ submit: false, confirm: false })}
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              <RedLogo />
            </p>
            <h1 className="subscription-name red">Report User</h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                  <p className="sub-section red">User Reported:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div
                    className={
                      role === "mentor"
                        ? "avi-color-border-alt red"
                        : role === "innovator"
                        ? "avi-color-border-alt green"
                        : "avi-color-border-alt blue"
                    }
                  >
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span
                        className={
                          role === "mentor"
                            ? "red name-font bold"
                            : role === "innovator"
                            ? "green name-font bold"
                            : "blue name-font bold"
                        }
                      >
                        {firstname} {lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{jobtitle}</li>
                    <li className="user-online-item">
                      {location && location.city}, {location && location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 red"></i>
                  <p className="sub-section red">Report submitted by:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div
                    className={
                      user.role === "mentor"
                        ? "avi-color-border-alt red"
                        : user.role === "innovator"
                        ? "avi-color-border-alt green"
                        : "avi-color-border-alt blue"
                    }
                  >
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                      className="sub-avi"
                      alt="avi-two"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span
                        className={
                          user.role === "mentor"
                            ? "red name-font bold"
                            : user.role === "innovator"
                            ? "green name-font bold"
                            : "blue name-font bold"
                        }
                      >
                        {user.firstname} {user.lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{user.jobtitle}</li>
                    <li className="user-online-item">
                      {user.location.city}, {user.location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sub-grid">
            <p className="user-request-text">
              This user has been reported and is currently under review. Here is
              a snapshot of the report you submitted:
              <br />
              <br />
              <span className="red bold">Reason for report:</span>{" "}
              {racism && "Racism"} {inappropriate && "Inappropriate"}{" "}
              {spam && "Spam"} {impersonation && "Impersonation"}{" "}
              {threat && "Threat"} {other && "Other"}
              <br /> <br />
              <span className="red bold">Description:</span> {text}
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ReportUserConfirm;
